/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
// @ts-nocheck
import React, { Suspense, lazy } from "react";
import {
    BrowserRouter as Router,
    Switch,
    Route,
    Link,
    Redirect,
} from "react-router-dom";
import { TypeWriterLoaderVW } from "@vlinder-web/typewriter-loader-widget-react";

const { isAuthenticated } = {};

const TrinetrPage = lazy(() => import("../pages/Trinetr"));

const RouterConfig = (props) => (
    <Switch>
        <Route path="/" component={TrinetrPage} />
    </Switch>
);

const PrivateRoute = ({ component: Component, ...rest }) => (
    <Route
        {...rest}
        render={(props) =>
            isAuthenticated() ? (
                <Component {...props} />
            ) : (
                <Redirect
                    to={{
                        pathname: `/login`,
                    }}
                />
            )
        }
    />
);

function RouteWithSubRoutes(route) {
    return (
        <Route
            path={route.path}
            render={(props) => (
                // pass the sub-routes down to keep nesting
                <route.component {...props} routes={route.routes} />
            )}
        />
    );
}

export const AppNavigator = (): JSX.Element => {
    return (
        <Router>
            <Suspense fallback={<TypeWriterLoaderVW />}>
                <RouterConfig />
            </Suspense>
        </Router>
    );
};
